import React from 'react';
import Modal from 'src/modules/shared/modal/components/modalNEW';
import NHSContent from './NHSContent';

const contentModal = ({tagName}) => (
  <Modal title={tagName}>
    <NHSContent/>
  </Modal>
);

export default contentModal;
